import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { UserUtilities } from "../../../shared/user.utilities";
// COMPONENT SERVICES
import { AdminHeaderService } from "../../../components/layouts/administrator/admin-header/admin-header.service";
import { Appsettings } from "../../../configuration/appsettings";

// COMPONENT SERVICES
import { AdminNavService } from "../../../components/layouts/administrator/admin-nav/admin-nav.service";

// Servicios
import {
  StructureService,
  StorageService,
  CatalogService,
  UserService,
} from "../../../service/service.index";

// Modelo
import { Node } from "../../../models/content/node.model";
import { Repeatcontent } from "src/app/models/content/repeatcontent.model";
import { Content } from "../../../models/content/content.model";
import { ContentType } from "../../../models/content/contentType.mode";
import { Pagination } from "../../../models/general/pagination.model";
import { Block } from "../../../models/catalogs/block.model";
import { Formative } from "../../../models/catalogs/formativeField.model";
import { Event } from "../../../models/content/event.model";
import swal from "sweetalert2";
import { User } from "../../../models/security/user.model";

import { AreaPersonalSocialDevelopment } from "../../../models/catalogs/areaPersonalSocialDevelopment.model";
import { AreasCurriculumAutonomy } from "../../../models/catalogs/areasCurriculumAutonomy.model";
import { Axis } from "../../../models/catalogs/axis.model";
import { KeyLearning } from "../../../models/catalogs/keyLearning.model";
import { LearningExpected } from "../../../models/catalogs/learningExpected.model";
import { Purpose } from "../../../models/catalogs/purpose.model";
import { EducationLevel } from "../../../models/catalogs/educationLevel.model";

declare function setFullHeightWithOffset(selement, offset): any;
import { JoyrideService } from "ngx-joyride";
declare var dataLayer;

@Component({
  selector: "app-content",
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
})
export class ContentComponent implements OnInit, OnDestroy {
  textSearch = "";
  textNotFound =
    "No se encontró ningún recurso, verifica que el nombre este escrito correctamente";
  full: boolean;
  structureParentId: number;
  blocks: Block[] = [];
  formativeField: Formative[] = [];
  nodes: any[] = [];
  children: any[] = [];
  grados: any[] = [];
  asignaturas: any[] = [];
  idMateria;
  iDformative;
  content: Content[] = [];
  contentType: ContentType[] = [];
  resources: Content[] = [];
  selectTypeFile: number[] = [];
  typeResource: string;
  nodeId: number;
  totalResources: number;
  selectedParent: Node;
  showResources: boolean;
  fileTypeId: number;
  fileTypesIds: string;
  working: boolean;
  sizePage: string = Appsettings.DEFAULT_SIZE_PAGE;
  page = 1;
  pagination: Pagination = new Pagination();
  // Variable para el numero de pagina
  currentPage = 1;
  blockId: number;
  formativeId: number;
  showFilters: boolean;
  showFiltersCatalog: boolean;
  typeId: number;

  // Se agrega variable para obtener la informaciòn del usuario masantosa 01/08/2019
  userData: any[] = [];
  userEmail: string;

  areaPersonalSocialDevelopment: AreaPersonalSocialDevelopment[] = [];
  areaPersonalSocialDevelopmentRes: AreaPersonalSocialDevelopment[] = [];
  areaPersonalSocialDevelopmentId: number;

  areasCurriculumAutonomy: AreasCurriculumAutonomy[] = [];
  areasCurriculumAutonomyRes: AreasCurriculumAutonomy[] = [];
  areasCurriculumAutonomyId: number;

  axis: Axis[] = [];
  axisRes: Axis[] = [];
  axisId: number;

  keylearning: KeyLearning[] = [];
  keylearningRes: KeyLearning[] = [];
  keylearningId: number;

  learningexpected: LearningExpected[] = [];
  learningexpectedRes: LearningExpected[] = [];
  learningexpectedId: number;

  purposes: Purpose[] = [];
  purposeId: number;

  educationLevel: EducationLevel[] = [];
  educationLevelId: number;

  educationLevelSelectdId: number;

  descriptionBradcun: any;
  contentResourceTypeId = 1;

  countCyclesBachiller = 0;
  levelsOmited: any[] = [];
  levelsSubsistemasChildrens: any[] = [];
  selectedParentNew = 0;
  levelBachillerato: any = {};
  levelRecursos: any = {};

  idTypeFile: any;

  isRecursos: boolean = true;

  constructor(
    public _srvHeaderAdmin: AdminHeaderService,
    private _srvUser: UserService,
    private _srvStructure: StructureService,
    public _srvStorage: StorageService,
    private route: ActivatedRoute,
    private _router: Router,
    private _srvCatalogS: CatalogService,
    public _srvAdminNav: AdminNavService,
    private joyride: JoyrideService
  ) {
    this.showResources = true;
    this.selectedParent = new Node();
    this._srvStorage.showBackBotton = true;

    this.blockId = 0;
    this.iDformative = 0;
    this.areaPersonalSocialDevelopmentId = 0;
    this.areasCurriculumAutonomyId = 0;
    this.axisId = 0;
    this.keylearningId = 0;
    this.learningexpectedId = 0;
    this.purposeId = 0;
    this.educationLevelId = 0;
    this.totalResources = 0;
    this.educationLevelSelectdId = 0;

    this.route.params.subscribe((params) => {
      this.nodes = [];
      this.nodeId = Number(_srvStorage.nodeRoot);

      let nodeIds: number[] = [];
      nodeIds.push(this.nodeId);

      console.log(params.fileType);
      this.idTypeFile = params.fileType;
      this.typeId = Number(params.nodeId);
      if (this.typeId === 0) {
        // this.getContentNode(this.nodeId, nodeIds);
      } else {
        /** */
        if (this.typeId == 2) {
          this.contentResourceTypeId = 0;
        }
        this.getContentNodeHelp(this.nodeId, nodeIds);
        /** */
      }
      this.getBlockAll();
      const data = JSON.parse(this._srvStorage.nodes);
      const filtrado = data.filter(
        (item) => item.id !== 143 && item.id !== 144
      );

      if (
        _srvStorage.rol === "Alumno Bachillerato" ||
        _srvStorage.rol === "Profesor Bachillerato"
      ) {
        this.levelsOmited = [];
        let filtradoInList: any[] = [];
        filtradoInList = filtrado;
        let filterOmited: any[] = [];
        let materiasBachillerato: any[] = [];

        let subSystemasBachillerato: any[] = [];
        let subSystemFilter: any[] = [];

        let listVariants: string[] = [];
        listVariants.push(
          "Plan Lector",
          "Libro Algebra Baldor",
          "Serie BALDOR",
          "UNITEC",
          "SABES Guanajuato"
        );

        if (this.typeId === 0) {
          this.getChildrensOmited2(filtrado);
          filterOmited = this.removeListFromList(this.levelsOmited, filtrado);
          subSystemasBachillerato = filtradoInList.filter(
            (z) => z.parentId === 1448
          );

          subSystemasBachillerato.forEach((y) => {
            let exist: boolean = false;
            listVariants.forEach((l) => {
              if (y.description === l) {
                exist = true;
              }
            });

            if (!exist) {
              subSystemFilter.push(y);
            }
          });

          this.levelBachillerato = filtradoInList.filter((z) => z.id === 1448);
          this.levelRecursos = filtradoInList.find((x) => x.id === Number(this._srvStorage.nodeRoot));
          materiasBachillerato = this.getNextLevel(filterOmited);

          materiasBachillerato.push(this.levelBachillerato[0]);
          materiasBachillerato.push(this.levelRecursos);
          materiasBachillerato.push(...subSystemFilter);

          for (const node of materiasBachillerato) {
            const childrens = new Node();
            childrens.id = node.id;
            childrens.active = node.active;
            childrens.description = node.description;
            childrens.nodeTypeId = node.nodeTypeId;
            childrens.parentId = node.parentId;
            childrens.urlImage = node.urlImage;
            childrens.idsAssociate = node.idsAssociate;

            this.nodes.push(childrens);
          }
          const parent = this.nodes.filter((item) => item.parentId === 0)[0];
          const children = new Node();
          children.id = parent.id;
          children.active = parent.active;
          children.description = parent.description;
          children.nodeTypeId = parent.nodeTypeId;
          children.parentId = parent.parentId;
          children.urlImage = parent.urlImage;
          this.children = this.nodes.filter(
            (item) =>
              item.parentId === children.id &&
              item.id !== 143 &&
              item.id !== 144
          );

          this.selectedParent = children;
        } else {
          this.getChildrensOmited2(filtrado);
          filterOmited = this.removeListFromList(this.levelsOmited, filtrado);
          this.levelBachillerato = filtradoInList.filter((z) => z.id === 1448);
          this.levelRecursos = filtradoInList.find((x) => x.id === Number(this._srvStorage.nodeRoot));
          materiasBachillerato = this.getNextLevel(filterOmited);

          materiasBachillerato.push(this.levelBachillerato[0]);
          materiasBachillerato.push(this.levelRecursos);
          for (const node of materiasBachillerato) {
            const childrens = new Node();
            childrens.id = node.id;
            childrens.active = node.active;
            childrens.description = node.description;
            childrens.nodeTypeId = node.nodeTypeId;
            childrens.parentId = node.parentId;
            childrens.urlImage = node.urlImage;
            childrens.idsAssociate = node.idsAssociate;

            this.nodes.push(childrens);
          }

          const parent = this.nodes.filter((item) => item.parentId === 0)[0];
          const children = new Node();
          children.id = parent.id;
          children.active = parent.active;
          children.description = parent.description;
          children.nodeTypeId = parent.nodeTypeId;
          children.parentId = parent.parentId;
          children.urlImage = parent.urlImage;
          this.children = this.nodes.filter(
            (item) =>
              item.parentId === children.id &&
              item.id !== 143 &&
              item.id !== 144
          );

          this.selectedParent = children;
        }

        /*  
       this.getChildrensOmited(filtrado);
       filterOmited = this.removeListFromList(this.levelsOmited, filtrado);
       this.levelBachillerato = filtradoInList.filter((z) => z.id === 1448);

        this.levelRecursos = filtradoInList.find((x) => x.id === 124);
        materiasBachillerato = this.getNextLevel(filterOmited);

        materiasBachillerato.forEach((l) => {
          let listVariants: string[] = [];
          listVariants.push(
            ".",
            "v",
            "p",
            "UDG",
            "DGB",
            "U",
            "Q",
            "1O",
            "2O",
            "Competent",
            "-R",
            "UNITEC",
            " "
          );

          listVariants.forEach((x) => {
            switch (x) {
              default:
                if (l.description.endsWith(x)) {
                  ///const newName = l.description.substring(0,l.description - x.length);

                  const newName = l.description.slice(
                    0,
                    l.description.lastIndexOf(x)
                  );
                  //console.log(newName);
                  l.description = newName;
                }
                break;
            }
          });
        });

        materiasBachillerato.sort((a, b) =>
          b.description.localeCompare(a.description)
        );
        materiasBachillerato = this.getRepeater(materiasBachillerato);

        materiasBachillerato.forEach((z) => {
          z.parentId = 1448;
        });

        materiasBachillerato.sort((a, b) =>
          b.description.localeCompare(a.description)
        );

        materiasBachillerato.push(this.levelBachillerato[0]);
        materiasBachillerato.push(this.levelRecursos);
        materiasBachillerato.reverse();

        //materiasBachillerato.forEach()

        for (const node of materiasBachillerato) {
          const childrens = new Node();
          childrens.id = node.id;
          childrens.active = node.active;
          childrens.description = node.description;
          childrens.nodeTypeId = node.nodeTypeId;
          childrens.parentId = node.parentId;
          childrens.urlImage = node.urlImage;
          childrens.idsAssociate = node.idsAssociate;

          this.nodes.push(childrens);
        }

        const parent = this.nodes.filter((item) => item.parentId === 0)[0];
        const children = new Node();
        children.id = parent.id;
        children.active = parent.active;
        children.description = parent.description;
        children.nodeTypeId = parent.nodeTypeId;
        children.parentId = parent.parentId;
        children.urlImage = parent.urlImage;
        this.children = this.nodes.filter(
          (item) =>
            item.parentId === children.id && item.id !== 143 && item.id !== 144
        );

        this.selectedParent = children;*/
      } else {
        for (const node of filtrado) {
          const childrens = new Node();
          childrens.id = node.id;
          childrens.active = node.active;
          childrens.description = node.description;
          childrens.nodeTypeId = node.nodeTypeId;
          childrens.parentId = node.parentId;
          childrens.urlImage = node.urlImage;

          this.nodes.push(childrens);
        }

        const parent = this.nodes.filter((item) => item.parentId === 0)[0];
        const children = new Node();
        children.id = parent.id;
        children.active = parent.active;
        children.description = parent.description;
        children.nodeTypeId = parent.nodeTypeId;
        children.parentId = parent.parentId;
        children.urlImage = parent.urlImage;
        this.children = this.nodes.filter(
          (item) =>
            item.parentId === children.id && item.id !== 143 && item.id !== 144
        );
        this.selectedParent = children;
      }
    });
  }

  // this.children = this.nodes.filter(item => item.parentId === children.id);
  // if (this.children.length > 0) {
  //   this.onClickSelectNode(this.children[0]);
  // }

  getRepeater(listCheck: any[]) {
    listCheck.sort((a, b) => b.description.localeCompare(a.description));
    let listCheckClon: any[] = [];
    let listRepeat: any[] = [];
    let listNotRepeat: any[] = [];
    let listRepeatcontent: Repeatcontent[] = [];
    let listNotRepeatcontent: Repeatcontent[] = [];
    let listRepeatcontentMix: Repeatcontent[] = [];
    let listFinal: Node[] = [];

    listCheckClon.push(...listCheck);

    listCheck.forEach((x) => {
      let found: any[] = [];

      /*found = listCheckClon.filter(
        (z) => z.description.indexOf(x.description) > -1
      );*/

      found = listCheckClon.filter((z) => z.description === x.description);

      if (found.length > 1) {
        let groupRepeate: Repeatcontent = new Repeatcontent();
        groupRepeate.listContents.push(...found);
        listRepeat.push(...found);
        listRepeatcontent.push(groupRepeate);

        found.forEach((e) => {
          const indexToRemove = listCheckClon.findIndex((s) => s.id === e.id);
          listCheckClon.splice(indexToRemove, 1);
        });
      }
    });

    listNotRepeat = listCheckClon;

    listCheckClon.forEach((k) => {
      let groupRepeate: Repeatcontent = new Repeatcontent();
      let listUnique: any[] = [];
      listUnique.push(k);
      groupRepeate.listContents.push(...listUnique);
      listNotRepeatcontent.push(groupRepeate);
    });

    listRepeatcontentMix.push(...listRepeatcontent);
    listRepeatcontentMix.push(...listNotRepeatcontent);

    listRepeatcontentMix.forEach((l) => {
      let nodeN: Node = new Node();
      let node: any = {};
      let listIdAssociate: number[] = [];

      l.listContents.forEach((m) => {
        listIdAssociate.push(m.id);
      });

      node = l.listContents[l.listContents.length - 1];

      nodeN.id = node.id;
      nodeN.active = node.active;
      nodeN.description = node.description;
      nodeN.nodeTypeId = node.nodeTypeId;
      nodeN.parentId = node.parentId;
      nodeN.urlImage = node.urlImage;
      nodeN.idsAssociate = listIdAssociate;

      listFinal.push(nodeN);
    });

    return listFinal;
  }

  removeListFromList(listToRemove: any[], listOriginal: any[]) {
    const listFilter: any[] = [];
    listOriginal.forEach((x) => {
      const found = listToRemove.find((y) => x.id == y.id);
      if (found == null) {
        listFilter.push(x);
      }
    });

    return listFilter;
  }

  getNextLevel(listFilter: any[]) {
    let nextLevels: any[] = [];
    let founded: any[] = [];

    this.levelsSubsistemasChildrens.forEach((o) => {
      founded = listFilter.filter((x) => x.parentId == o.id);
      nextLevels.push(...founded);
    });

    return nextLevels;
  }

  getChildrensOmited(filtrado: any[]) {
    if (this.countCyclesBachiller == 0) {
      filtrado.forEach((element) => {
        if (element.parentId == 1448) {
          this.levelsOmited.push(element);
        }
      });

      this.countCyclesBachiller = 1;

      if (this.countCyclesBachiller == 1) {
        this.levelsOmited.forEach((e) => {
          const found = filtrado.filter((i) => i.parentId === e.id);
          found.forEach((x) => {
            this.levelsSubsistemasChildrens.push(x);
          });
        });
      }

      this.levelsOmited.push(...this.levelsSubsistemasChildrens);
      this.countCyclesBachiller = 2;
    }
  }

  getChildrensOmited2(filtrado: any[]) {
    let levelSubSystem: any[] = [];

    if (this.countCyclesBachiller == 0) {
      filtrado.forEach((element) => {
        if (element.parentId == 1448) {
          levelSubSystem.push(element);
        }
      });

      this.countCyclesBachiller = 1;

      if (this.countCyclesBachiller == 1) {
        levelSubSystem.forEach((e) => {
          const found = filtrado.filter((i) => i.parentId === e.id);
          found.forEach((x) => {
            this.levelsSubsistemasChildrens.push(x);
          });
        });
      }

      this.levelsOmited.push(...this.levelsSubsistemasChildrens);
      this.countCyclesBachiller = 2;
    }
  }

  ngOnInit() {
    if (this.content.length === 0) {
    }
    this.showFilters = false;
    this.showFiltersCatalog = false;
    let title = "Material didáctico";
    switch (this.typeId) {
      case 0:
        title = "Guías del maestro";
        break;
      case 2:
        title = "Recursos digitales";
        break;
      default:
        break;
    }
    this._srvAdminNav.setTitle(title);
    this._srvHeaderAdmin.setUrlBackButton(["/resource/home", "Inicio"]);
    setFullHeightWithOffset(".nav-structure", 70);
    this.getDataCatalogs();
  }

  ngOnDestroy(): void {
    this._srvHeaderAdmin.setUrlBackButton([]);
  }

  getDataCatalogs() {
    this._srvCatalogS.requestCatalogos().subscribe((data) => {
      this.setAreaPersonal(data[0]);
      this.setAreasCurriculums(data[1]);
      this.setAxis(data[2]);
      this.setKeyLearning(data[3]);
      this.setLearningExpected(data[4]);
      this.setPurposes(data[5]);
      this.setEduationLevel(data[6]);
      this.getFormativeFieldAll(data[7]);
    });
  }

  /*********** SETEO DE LOS CATALOGOS PARA FILTROS  ********/
  // Setea el catalogo de areas personal
  setEduationLevel(data) {
    if (data.success) {
      this.educationLevel = [];
      let datas = data.data;
      for (let e of datas) {
        let level = new EducationLevel();
        level.id = e.id;
        level.active = e.active;
        level.description = e.description;
        this.educationLevel.push(level);
      }
    }
  }
  // Setea el catalogo de areas personal
  setAreaPersonal(data) {
    if (data.success) {
      this.areaPersonalSocialDevelopment = [];
      this.areaPersonalSocialDevelopmentRes = [];
      let datas = data.data;
      for (let e of datas) {
        let area = new AreaPersonalSocialDevelopment();
        area.id = e.id;
        area.fileTypeId = e.fileTypeId;
        area.description = e.description;
        area.educationLevelId = e.educationLevelId;
        area.name = e.description;
        this.areaPersonalSocialDevelopment.push(area);
        this.areaPersonalSocialDevelopmentRes.push(area);
      }
    }
  }
  // Setea el catalogo de areas de curriculares
  setAreasCurriculums(data) {
    if (data.success) {
      this.areasCurriculumAutonomy = [];
      this.areasCurriculumAutonomyRes = [];
      let datas = data.data;
      for (let e of datas) {
        let area = new AreasCurriculumAutonomy();
        area.id = e.id;
        area.active = e.active;
        area.description = e.description;
        area.educationLevelId = e.educationLevelId;
        area.name = e.description;
        this.areasCurriculumAutonomy.push(area);
        this.areasCurriculumAutonomyRes.push(area);
      }
    }
  }

  // Setea el catalogo de eje / ambito
  setAxis(data) {
    if (data.success) {
      this.axis = [];
      this.axisRes = [];
      let datas = data.data;
      for (let e of datas) {
        let axis = new Axis();
        axis.id = e.id;
        axis.active = e.active;
        axis.description = e.description;
        axis.educationLevelId = e.educationLevelId;
        axis.name = e.description;
        this.axis.push(axis);
        this.axisRes.push(axis);
      }
    }
  }

  // Setea el catalogo de aprendizaje clave
  setKeyLearning(data) {
    if (data.success) {
      this.keylearning = [];
      this.keylearningRes = [];
      let datas = data.data;
      for (let e of datas) {
        let key = new KeyLearning();
        key.id = e.id;
        key.active = e.active;
        key.description = e.description;
        key.educationLevelId = e.educationLevelId;
        key.name = e.description;
        this.keylearning.push(key);
        this.keylearningRes.push(key);
      }
    }
  }

  // Setea el catalogo de aprendizaje esperado
  setLearningExpected(data) {
    if (data.success) {
      this.learningexpected = [];
      this.learningexpectedRes = [];
      let datas = data.data;
      for (let e of datas) {
        let expeted = new LearningExpected();
        expeted.id = e.id;
        expeted.active = e.active;
        expeted.description = e.description;
        expeted.educationLevelId = e.educationLevelId;
        expeted.name = e.description;
        this.learningexpected.push(expeted);
        this.learningexpectedRes.push(expeted);
      }
    }
  }

  // Setea el catalogo de PROPOSITO
  setPurposes(data) {
    if (data.success) {
      this.purposes = [];
      let datas = data.data;
      for (let e of datas) {
        let purpose = new Purpose();
        purpose.id = e.id;
        purpose.description = e.description;
        purpose.name = e.description;
        this.purposes.push(purpose);
      }
    }
  }
  /*********** FIN PARA FILTROS  ********/
  onKeyUp(event) {
    if (this.textSearch.length >= 4 || this.textSearch.length === 0) {
      this.setPage({ page: 1, size: this.sizePage });
    }
  }

  onClickSelectNode(node) {
    console.log("hol");

    // this.validateLevel( node.id);

    this.showFilters = false;
    this.showFiltersCatalog = false;
    this.typeResource = "";
    this.showResources = true;
    this.nodeId = node.id;
    this.resources = [];
    this.selectTypeFile = [];
    const idAssocites = node.idsAssociate;
    let nodesIds: number[] = [];

    if (idAssocites !== undefined) {
      nodesIds.push(...idAssocites);
    } else {
      nodesIds.push(node.id);
    }

    if (this.typeId === 0 || this.typeId === 2) {
      this.getContentNode(this.nodeId, nodesIds);
    } else {
      this.getContentNodeHelp(this.nodeId, nodesIds);
    }
    let forDeletion = [1452, 2722, 1457, 2741];
    this.selectedParent = node;
    // this.children = this.nodes.filter((item) => item.parentId === node.id);
    // this.children = this.children.filter(
    //   (item) => !forDeletion.includes(item.id)
    // );

    this.getBreadcrumb(node.id);
  }

  // Regresar un nivel anteriro de la búsqueda
  onClickReturn(node: Node) {
    this.validateLevel(node.id);

    this.typeResource = "";
    this.resources = [];
    this.selectTypeFile = [];
    this.showResources = true;

    let listVariants: string[] = [];
    listVariants.push(
      "Plan Lector",
      "Libro Algebra Baldor",
      "Serie BALDOR",
      "UNITEC",
      "SABES Guanajuato"
    );

    this.nodes.forEach((x, i) => {
      listVariants.forEach((y) => {
        if (x.description === y) {
          this.nodes.splice(i, 1);
        }
      });
    });

    const parent = this.nodes.filter((x) => x.id === node.parentId)[0];

    let nodeIds: number[] = [];
    nodeIds.push(parent.id);

    if (this.typeId === 0) {
      // this.getContentNode(parent.id, nodeIds);
    } else {
      this.getContentNodeHelp(parent.id, nodeIds);
    }
    this.selectedParent = parent;
    this.children = this.nodes.filter((x) => x.parentId === parent.id);
    // if (this.children.length > 0) {
    //   this.onClickSelectNode(this.children[0]);
    // }
    this.getBreadcrumb(parent.id);
    this.showFilters = false;
    this.showFiltersCatalog = false;
  }

  // Obtiene el contenido por nodo para help
  getContentNodeHelp(nodeId: number, nodesId: number[]) {
    const stringNode = JSON.stringify(nodesId);

    this.working = true;
    this._srvStructure
      .getContentbyNodeId(
        nodeId,
        0,
        1,
        this.blockId,
        this.iDformative,
        0,
        nodesId,
        stringNode
      )
      .subscribe((result) => {
        if (result.data) {
          this.totalResources = result.pagination.total;

          this.contentType = [];
          this.content = [];
          const fileTypes = result.data.fileTypes;
          // Obtenemos los tipos de archivos
          for (const dataType of fileTypes) {
            const type = new ContentType();
            type.id = dataType.id;
            type.description = dataType.description;
            if (dataType.id === this.typeId) {
              this.contentType.push(type);
            }
          }
          // this.totalResources = this.contentType.length;
        }

        if (this.typeId === 16) {
          this.onSelectTypeContent(this.typeId);
        } else {
          this.working = false;
        }
      });
  }

  getContentNode(nodeId: number, nodesId: number[]) {
    const stringNode = JSON.stringify(nodesId);
    this.working = true;
    this._srvStructure
      .getContentbyNodeId(
        nodeId,
        0 ,//this.idTypeFile,
        1,
        this.blockId,
        this.iDformative,
        this.contentResourceTypeId,
        nodesId,
        stringNode
        //stringNode
      )
      .subscribe((result) => {
        if (result.data) {
          this.totalResources = result.pagination.total;

          this.contentType = [];
          this.content = [];
          const fileTypes = result.data.fileTypes;
          // Obtenemos los tipos de archivos
          for (const dataType of fileTypes) {
            const type = new ContentType();
            type.id = dataType.id;
            type.description = dataType.description;

            this.contentType.push(type);
          }
          // this.totalResources = this.contentType.length;
        }
        this.working = false;
        // if (this.typeId === 16) {
        //   this.onSelectTypeContent(this.typeId);
        // } else {
        //   if (this.contentType.length > 0) {
            this.onSelectTypeContent(this.contentType[0].id);
        //   } else {
        //     this.working = false;
        //   }
        // }
      });
  }

  setPage(paginationData: object) {
    this.working = true;
    this.totalResources = 0;
    if (this.fileTypesIds === undefined) {
      this.fileTypesIds = "0";
    }
    // tslint:disable-next-line:max-line-length
    this._srvStructure
      .getContentbyTypeId(
        this.nodeId,
        this.idTypeFile,
        this.currentPage,
        this.blockId,
        this.iDformative,
        this.textSearch,
        this.areaPersonalSocialDevelopmentId,
        this.areasCurriculumAutonomyId,
        this.axisId,
        this.keylearningId,
        this.learningexpectedId,
        this.purposeId,
        this.educationLevelId,
        this.contentResourceTypeId
      )
      .subscribe((result) => {
        this.content = [];
        if (result.success) {
          this.pagination.pageNumber = Number(paginationData["page"]);
          this.pagination.pageSize = result.pagination.pageSize;
          this.pagination.showNextPage = result.pagination.showNextPage;
          this.pagination.showPreviousPage = result.pagination.showPreviousPage;
          this.pagination.total = result.pagination.total;
          this.pagination.totalPage = result.pagination.totalPage;

          this.totalResources = result.pagination.total;

          this.sizePage = paginationData["size"];

          const files = result.data.files;

          if (files.length > 0) {
            // Obtenemos los archivos
            for (const f of files) {
              const resource = new Content();
              resource.active = f.active;
              resource.area = f.area;
              resource.content = f.content;
              resource.contentResourceType = f.contentResourceType;
              resource.contentTypeDesc = f.contentTypeDesc;
              resource.contentTypeId = f.contentTypeId;
              resource.fileTypeDesc = f.fileTypeDesc;
              resource.fileTypeId = f.fileTypeId;
              resource.formativeField = f.formativeField.description;
              resource.id = f.id;
              resource.isPublic = f.isPublic;
              resource.name = f.name;
              resource.purpose = f.purpose.description;
              resource.thumbnails = f.thumbnails;
              resource.totalContent = f.totalContent;
              resource.trainingField = f.trainingField;
              resource.urlContent = f.urlContent;
              resource.block = f.block.description;
              resource.description = f.description;
              resource.purposeId = f.purposeId;
              resource.axis = f.axis.description;
              resource.formativeFieldName = f.formativeField.description;
              resource.purposeName = f.purpose.description;
              this.content.push(resource);
            }
            // this.totalResources =  (this.contentType.length > 0 ) ? this.content.length : 0;
            this.showResources = this.content.length > 0 ? false : true;

            if (this.textSearch) {
              dataLayer.push(function () {
                this.reset();
              });
              dataLayer.push({
                event: "ev_search",
                category: "search",
                action: this.textSearch,
                label: this.content.length,
              });
            }

            if (files.length == 0 && this.textSearch.trim().length > 0) {
              swal(Appsettings.APP_NAME, this.textNotFound, "warning");
            }
          } else {
            this.working = false;

            if (files.length == 0 && this.textSearch.trim().length > 0) {
              swal(Appsettings.APP_NAME, this.textNotFound, "warning");
            }

            //swal(Appsettings.APP_NAME, 'Para visualizar contenido seleccione un nivel.', 'warning');
          }
        } else {
          swal(Appsettings.APP_NAME, result.message, "warning");
          this.working = false;
        }
        this.working = false;
        console.log(this._srvStorage.showTourMaterial);

        if (this._srvStorage.showTourMaterial === 0) {
          this._srvStorage.showTourMaterial = 1;
          this.joyride.startTour({
            steps: ["firstStepIcon", "firstStep0"],
            customTexts: {
              next: ">>",
              prev: "<<",
              done: "Cerrar",
            },
          });
        }
      });
  }

  // Busca los contenidos filtrados por tipo
  onSelectTypeContent(contentTypeId: number) {
    this.working = true;
    // if ( this.typeId === contentTypeId ) {
    //   this.typeId = 0;
    // }
    this.content = [];
    const res = this.selectTypeFile.indexOf(contentTypeId);
    if (res !== -1) {
      this.selectTypeFile.splice(res, 1);
    } else {
      this.selectTypeFile.push(Number(contentTypeId));
    }

    const idsType = this.selectTypeFile.join(",");

    this.fileTypesIds = idsType;

    if (this.selectTypeFile.length > 0) {
      this.showFilters = true;
      this.showFiltersCatalog = true;

      this.setPage({ page: this.currentPage });
    } else {
      this.working = false;
      this.showFilters = false;
      this.showFiltersCatalog = false;
    }
    this.fileTypeId = contentTypeId;
  }

  // Crea el camino de navegacion
  getBreadcrumb(nodeId: number) {
    const router = UserUtilities.getSelectedNodeUrl(
      nodeId,
      this._srvStorage.nodes
    );
    const descriptions = router.map((x) => x.description);
    this.descriptionBradcun = router.map((x) => x.description);
    this._srvHeaderAdmin.setBreadcrumb(descriptions);
  }

  selectShowMultimedia(content: Content) {
    // Se agrega la función para realizar la inserción de los eventos dentro del contenido multimedia

    // this._srvUser.insertEventSIDE();
    this._srvStorage.content = JSON.stringify(content);
    this._router.navigateByUrl(`/resource/show-multimedia/${this.nodeId}`);
  }

  onChangePage(page: number, cantContinue: boolean) {
    if (!cantContinue) {
      this.currentPage = page;
      this.setPage({ page: page, size: this.sizePage });
    }
  }

  getCSSActive(id: number) {
    let cssActive;
    this.selectTypeFile.forEach((element) => {
      if (element === id) {
        cssActive = { "active-file": true };
      }
    });
    return cssActive;
  }

  // Obtiene los bloques
  getBlockAll() {
    this.blocks = [];
    this._srvCatalogS.getBlockAll().subscribe((result) => {
      if (result.success) {
        for (const b of result.data) {
          const block = new Block();
          block.id = b.id;
          block.description = b.description;

          this.blocks.push(block);
        }
      }
    });
  }

  // Obtiene los campos formativos
  getFormativeFieldAll(data) {
    this.formativeField = [];
    if (data.success) {
      for (const f of data.data) {
        const formative = new Formative();
        formative.id = f.id;
        formative.description = f.description;
        formative.name = f.description;

        this.formativeField.push(formative);
      }
    }
  }

  onChangeSelect(name: string, event) {
    this.working = true;
    this.totalResources = 0;

    let action = this.descriptionBradcun[1];

    if (this.descriptionBradcun.length >= 4) {
      action = action + " | " + this.descriptionBradcun[3];
    }
    dataLayer.push(function () {
      this.reset();
    });
    dataLayer.push({
      event: "ev_content_filter",
      category: "content_filter",
      action: action,
      label: name + " | " + event.name,
    });
    // tslint:disable-next-line:max-line-length
    this._srvStructure
      .getContentbyTypeId(
        this.nodeId,
        this.fileTypesIds,
        this.currentPage,
        this.blockId,
        this.iDformative,
        this.textSearch,
        this.areaPersonalSocialDevelopmentId,
        this.areasCurriculumAutonomyId,
        this.axisId,
        this.keylearningId,
        this.learningexpectedId,
        this.purposeId,
        this.educationLevelId,
        this.contentResourceTypeId
      )
      .subscribe((result) => {
        this.content = [];

        if (result.success) {
          const files = result.data.files;
          // Obtenemos los archivos

          for (const f of files) {
            const resource = new Content();
            resource.active = f.active;
            resource.area = f.area;
            resource.content = f.content;
            resource.contentResourceType = f.contentResourceType;
            resource.contentTypeDesc = f.contentTypeDesc;
            resource.contentTypeId = f.contentTypeId;
            resource.fileTypeDesc = f.fileTypeDesc;
            resource.fileTypeId = f.fileTypeId;
            resource.formativeField = f.formativeField;
            resource.id = f.id;
            resource.isPublic = f.isPublic;
            resource.name = f.name;
            resource.purpose = f.purpose;
            resource.thumbnails = f.thumbnails;
            resource.totalContent = f.totalContent;
            resource.trainingField = f.trainingField;
            resource.urlContent = f.urlContent;
            resource.axis = f.axis.description;
            resource.formativeFieldName = f.formativeField.description;
            resource.purposeName = f.purpose.description;
            this.content.push(resource);
          }
          this.totalResources =
            this.contentType.length > 0 ? this.content.length : 0;

          this.showResources = this.content.length > 0 ? false : true;
        }
        this.working = false;
      });
  }

  // Cmabio de nivel escolar
  onSelectEducationLevel(event) {
    let id = event;

    this.axisId = 0;
    this.areaPersonalSocialDevelopmentId = 0;
    this.areasCurriculumAutonomyId = 0;
    this.keylearningId = 0;
    this.learningexpectedId = 0;

    this.showFiltersCatalog = id > 0 ? true : false;
    this.axis = this.axisRes.filter((x) => x.educationLevelId === id);
    this.areaPersonalSocialDevelopment =
      this.areaPersonalSocialDevelopmentRes.filter(
        (x) => x.educationLevelId === id
      );
    this.areasCurriculumAutonomy = this.areasCurriculumAutonomyRes.filter(
      (x) => x.educationLevelId === id
    );
    this.keylearning = this.keylearningRes.filter(
      (x) => x.educationLevelId === id
    );
    this.learningexpected = this.learningexpectedRes.filter(
      (x) => x.educationLevelId === id
    );
  }

  /************** TOOLTIPS  *************/
  getToolTipDataEducationLevel(event) {
    if (event !== undefined) {
      let tool = this.educationLevel.filter((x) => x.id === event)[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.educationLevelId = 0;
      }
    }
  }
  getToolTipDataselectedFortiveField(event) {
    if (event !== undefined) {
      let tool = this.formativeField.filter((x) => x.id === event)[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.iDformative = 0;
      }
    }
  }
  getToolTipDataAreaPersonal(event) {
    if (event !== undefined) {
      let tool = this.areaPersonalSocialDevelopment.filter(
        (x) => x.id === event
      )[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.areaPersonalSocialDevelopmentId;
      }
    }
  }
  getToolTipDataAreaCurriculum(event) {
    if (event !== undefined) {
      let tool = this.areasCurriculumAutonomy.filter((x) => x.id === event)[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.areasCurriculumAutonomyId = 0;
      }
    }
  }
  getToolTipDataAxis(event) {
    if (event !== undefined) {
      let tool = this.axis.filter((x) => x.id === event)[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.axisId = 0;
      }
    }
  }
  getToolTipDataKeylearning(event) {
    if (event !== undefined) {
      let tool = this.keylearning.filter((x) => x.id === event)[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.keylearningId = 0;
      }
    }
  }
  getToolTipDaTALearningexpected(event) {
    if (event !== undefined) {
      let tool = this.learningexpected.filter((x) => x.id === event)[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.learningexpectedId = 0;
      }
    }
  }
  getToolTipDataPurpose(event) {
    if (event !== undefined) {
      let tool = this.purposes.filter((x) => x.id === event)[0];
      if (tool !== undefined) {
        return tool.description;
      } else {
        this.purposeId = 0;
      }
    }
  }

  // valida el nivel de la estrucutra con el catalogo
  validateLevel(id: number) {
    // console.log( this.educationLevel );
    // 143 -> primaria
    // 144 -> preescolar
    // 145 -> secundaria
    let level = 0;
    switch (id) {
      case 143:
        let primaria = this.educationLevel.filter((x) => x.id === 2)[0];
        this.educationLevelSelectdId = primaria.id;
        this.onSelectEducationLevel(primaria.id);
        break;
      case 144:
        let preescolar = this.educationLevel.filter((x) => x.id === 1)[0];
        this.educationLevelSelectdId = preescolar.id;
        this.onSelectEducationLevel(preescolar.id);
        break;
      case 145:
        let secundaria = this.educationLevel.filter((x) => x.id === 3)[0];
        this.educationLevelSelectdId = secundaria.id;
        this.onSelectEducationLevel(secundaria.id);
        break;
      case 1448:
        let bachillerato = this.educationLevel.filter((x) => x.id === 4)[0];
        this.educationLevelSelectdId = bachillerato.id;
        this.onSelectEducationLevel(bachillerato.id);
        break;
      default:
        this.onSelectEducationLevel(this.educationLevelSelectdId);
        break;
    }
  }

  onChangeLevel($event) {
    console.log($event.value);
    this.idMateria = $event.value;
    this.grados = this.nodes.filter((item) => item.parentId === $event.value);
  }

  onChangeGrado($event) {
    console.log($event.value);
    this.idMateria = $event.value;
    this.asignaturas = this.nodes.filter(
      (item) => item.parentId === $event.value
    );
  }

  onChangeMateria($event) {
    this.idMateria = $event.value;
  }

  searchResource() {


    const node = this.nodes.filter((item) => item.id === this.idMateria);

    console.log(this.iDformative);

    this.onClickSelectNode(node[0]);
  }
}
